<app-question-progress-bar *ngIf="ready" [max]="totalQuestions" [answered]="totalQuestions - responses.length"></app-question-progress-bar>
<app-question *ngIf="ready" [response]="response" [answers]="answers" (questionReady)="questionReady()" (questionAnswered)="questionAnswered($event)"></app-question>
